import { oncallFetch } from "sc/backend/oncall/fetch-helper";

export default function*() {
  return yield oncallFetch("/api/oncall/administration/users/list", {});
}



// WEBPACK FOOTER //
// ./src/sc/backend/oncall/administration/users/list.js